function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "add_svg__New_Form_icon",
  "data-name": "New Form icon",
  className: "add_svg__cls-1",
  d: "M-2889.5-3331a7.509 7.509 0 01-7.5-7.5 7.509 7.509 0 017.5-7.5 7.509 7.509 0 017.5 7.5 7.508 7.508 0 01-7.5 7.5zm-.41-6.88v3.09h1.03v-3.09h3.09v-1.03h-3.09v-3.09h-1.03v3.09h-3.09v1.03z",
  transform: "translate(2897 3346)"
});

function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _ref, _ref2);
}

export default SvgAdd;